export default __webpack_public_path__ + "static/media/SCS-RecycledMaterialLogo.e8521b52.png";